import React from 'react';
import { NavLink } from 'react-router-dom';
import { ScanBarcode, LayoutDashboard, ArrowLeftRight } from 'lucide-react';

export default function Nav() {
    return (
        <nav className="bottom-nav">
            <NavLink to="/" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`} end>
                <ScanBarcode size={22} className="nav-icon" />
                Scan
            </NavLink>
            {/* Log tab hidden for now — code preserved in DailyLog.jsx
            <NavLink to="/log" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
                <ClipboardList size={22} className="nav-icon" />
                Log
            </NavLink>
            */}
            <NavLink to="/dashboard" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
                <LayoutDashboard size={22} className="nav-icon" />
                Dashboard
            </NavLink>
            <NavLink to="/swap" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
                <ArrowLeftRight size={22} className="nav-icon" />
                Swap
            </NavLink>
        </nav>
    );
}
